module.exports = __webpack_public_path__ + "static/media/action-icon-buttons-outlined-32-white-right-arrow.102744d3.svg";